import "./LbsSelect.css";
import React, { useState, useEffect } from "react";
import API from "../library/ApiManager";
import { ColorRing } from "react-loader-spinner";
import Loader from "react-loader-spinner";
import { v4 as uuidv4 } from "uuid";
import Fnc from "../library/Functions";
import { MDCTextField } from '@material/textfield';
import { MDCList } from '@material/list';
import { MDCTextFieldHelperText } from '@material/textfield/helper-text';
import { useRef } from "react";

function LbsSelect(props) {
	const [loading, setLoading] = useState(null);
	const [typed, setTyped] = useState("");
	const [dropdownList, setDropdownList] = useState([]);
	const [showError, setShowError] = useState(false);
	const [uuidList, setUuidList] = useState(false);
	const [elmChoosed, setElmChoosed] = useState(false);
	const [errorMsg, setErrorMsg] = useState(null);
	const [active, setActive] = useState(0);
	//const [eventSource, setEventSource] = useState(null);
	const useFocus = () => {
		const htmlElRef = useRef(null)
		const setFocus = () => { htmlElRef.current && htmlElRef.current.focus() }

		return [htmlElRef, setFocus]
	}
	const [inputRef, setInputFocus] = useFocus();

	const addType = "address";

	//const [, updateState] = React.useState();
	//const forceUpdate = React.useCallback(() => updateState({}), []);

	useEffect(() => {
		// Similar to componentDidMount and componentDidUpdate:
		setUuidList(uuidv4());

		//setTyped(props.value);
		const textField = [].map.call(document.querySelectorAll('.mdc-text-field'), function (el) {
			return new MDCTextField(el);
		});
		const helperText = [].map.call(document.querySelectorAll('.mdc-text-field-helper-text'), function (el) {
			return new MDCTextFieldHelperText(el);
		});
		const list = [].map.call(document.querySelectorAll('.mdc-list'), function (el) {
			return new MDCList(el);
		});
		setTyped(props.value);
	}, [props.forceDisabled, props.value]); //empty array => chiama solo una volta. Senza la chiama ad ogni cambiamento

	useEffect(() => {
		if (props.setFocus) {
			setInputFocus();
		}

	}, [props.setFocus]);

	function onInputChanged(e) {
		//if (eventSource !== 'list') {
		let val = e.target.value;
		setTyped(val);
		setElmChoosed(false); //azzero il flag per capire se è stato selezionato qualcosa dalla tendina

		if (val && val.length > 0) {
			setLoading(true);

			//------ configurazioni particolari impostazioni chiamata LBS 
			let opentipo = 0; //city
			if (props.type === addType) {
				opentipo = -1;
			}

			let valApi = props.preAppendVal && props.preAppendVal.length > 0 ? props.preAppendVal + " " + val : val;

			//-----
			API.lbs(valApi, opentipo, (data) => {
				if (data && data.r) {
					// ------ Filtriamo gli elementi per escludere quelli vuoti o che non sono perfettamente corrispondenti
					// let dataOk = data.r.filter(function (el) {
					//   let v = props.type === addType ? el.topo : el.com;
					//   return v && v.length > 0 && v.toLowerCase().includes(val.toLowerCase());
					// }).slice(0, 6);

					let dataOk = data.r
						.filter(function (el) {
							let v = props.type === addType ? el.topo : el.com;
							return v && v.length > 0;
						})
						.slice(0, 6);

					var retVals = dataOk.map((elm) => ({
						// required: what to show to the user
						label: props.type === addType ? elm.topo : (elm.fraz ? elm.fraz + ", " : "") + elm.com + " (" + elm.prov + ")",
						// required: key to identify the item within the array
						key: elm.cod,
						elm: elm,
					}));
					/*retVals.sort(function (a, b) {
						if (a.label < b.label) {
							return -1;
						}
						if (a.label > b.label) {
							return 1;
						}
						return 0;
					});*/
					setDropdownList(retVals);
					//forceUpdate();
				}
				setLoading(false);
			});
		} else {
			setDropdownList([]);
			props.callback(new Fnc.Ret(Fnc.EnmGen.KO));
		}
		//}
	}

	function onElmSelect(e) {
		let key = e.target.getAttribute("myid");

		jobSelect(key);
	}

	function jobSelect(key) {

		if (key && key.length > 0) {
			//ho un elemento selezionato

			let selElm = dropdownList.find(function (el) {
				return el.key.toString().toLowerCase() === key.toLowerCase();
			});
			if (selElm) {
				Fnc.log("SELECTED", selElm, Fnc.LogLvl.DEBUG);
				setShowError(false);
				setErrorMsg(null);
				setElmChoosed(true);
				props.callback(new Fnc.Ret(Fnc.EnmGen.OK, selElm));
				setTyped(selElm.label);
			} else {
				setShowError(true);
				setErrorMsg(Fnc.EnmGen.KO.msg);
				props.callback(new Fnc.Ret(Fnc.EnmGen.KO));
			}

			setDropdownList([]);

		} else {
			//NON ho un elemento selezionato
			setShowError(false);
			setErrorMsg(null);
			props.callback(new Fnc.Ret(Fnc.EnmGen.OK, null));
		}
	}

	function chiusuratendina(e) {
		setDropdownList([]);
		if (!elmChoosed) { //se NON è stato selezionato qualcosa dalla tendina allora mostro errore
			setShowError(true);
			setErrorMsg(Fnc.EnmGen.NOT_SELECTED.msg);
			props.callback(new Fnc.Ret(Fnc.EnmGen.NOT_SELECTED));
		}
	}

	const SelectLbs = useRef(null);
	const scrollTop = (ref) => {
		if (props.enablescroll) {
			if (window.innerWidth < 640) {
				window.scrollTo({
					top: SelectLbs.current.offsetTop + 50,
					behavior: 'smooth',
				});
			}
		};
	}

	function onKeyUp(event) {
		if (props.callbackKeyboard) {
			props.callbackKeyboard(event.keyCode);
		}
	}


	function onKeyDown(e) {
		if (e.keyCode === 13) {
			// enter key
			if (active !== undefined && active !== null) {
				let key = dropdownList[active].key + "";
				jobSelect(key);
			} else {
				//ha schiacciato enter con un valore valido senza tendina
				setElmChoosed(true);
				props.callback(new Fnc.Ret(Fnc.EnmGen.OK, null));
			}
			setActive(0);
		} else if (e.keyCode === 38) {
			// up arrow
			if (active > 0) {
				setActive(active - 1);
			}
		} else if (e.keyCode === 40) {
			// down arrow
			if (active < dropdownList.length - 1) {
				setActive(active + 1);
			}
		}
		else { setActive(0); }
	};

	return (

		<>
			<label className={`mdc-text-field mdc-text-field--outlined  ${(props.forceDisabled === true) && "mdc-text-field--disabled"} ${showError && "mdc-text-field--invalid"}`} ref={SelectLbs}>
				<input 
					type="text" 
					className={`form-control mdc-text-field__input ${(props.forceDisabled === true) && "disabled"} `} 
					aria-labelledby="my-label-id" 
					disabled={props.forceDisabled} 
					autoComplete="nope" 
					onClick={() => scrollTop(SelectLbs)}
					onBlur={chiusuratendina}
					onChange={onInputChanged}
					key={props.value}
					value={typed && typed.length > 0 ? typed : props.value}
					ref={inputRef}
					onKeyUp={onKeyUp} 
					onKeyDown={onKeyDown}/>
				  <span className="mdc-floating-label" id="my-label-id" >{props.label}<Loader visible={loading} className="loadingSpinner" type={Fnc.LoadingInp.TYPE} color={Fnc.LoadingInp.COLOR} height={Fnc.LoadingInp.HEIGHT} width={Fnc.LoadingInp.WIDTH} timeout={Fnc.LoadingInp.TIMEOUT} /></span>
					
			</label>
			<div className={`mdc-text-field-helper-line ${showError && "mdc-text-field--invalid"}`}>
				{showError && <div className="mdc-text-field-helper-text mdc-text-field-helper-text--persistent mdc-text-field-helper-text--validation-msg" role="alert">{errorMsg}</div>}
			</div>
			<div className="grid">
				<div className="g-col-12 g-col-md-12 list-container">
					<ul className={`mdc-deprecated-list ${(dropdownList.length > 0) && "shadow d-block"}`} id={uuidList ? uuidList : ""} >
						{dropdownList.map((item, index) => (
							<li className={`mdc-deprecated-list-item ${(index === active) && "activeul"}`} tabIndex="0" myid={item.key} onMouseDown={onElmSelect}>
								<span className="mdc-deprecated-list-item__ripple" myid={item.key} ></span>
								<span className="mdc-deprecated-list-item__text" myid={item.key} key={item.key} >{item.label}</span>
							</li>
						))}
					</ul>
				</div>
			</div>
		</>
	);
}

export default LbsSelect;
